import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CardLink } from "@sprout/client-components/dist/Card";
import { formatToReact } from "sprout-lib/dist/parser";
import { Flex, Box, Text } from "sprout-ui-primitives";
import { CheckOutlined } from "sprout-ui-icons";
import { getItemUrl } from "sprout-lib";
import styled from "styled-components";
const ActivityTodoDescription = styled(Text)`
  flex: auto;
  min-width: 0;

  font-size: 14px;
  line-height: 20px;
`;
const ActivityTodo = (props)=>{
    const { item , checked  } = props;
    const { description  } = item;
    return /*#__PURE__*/ _jsxs(Box, {
        position: "relative",
        pt: 1,
        children: [
            /*#__PURE__*/ _jsx(CardLink, {
                to: getItemUrl(item)
            }),
            /*#__PURE__*/ _jsxs(Flex, {
                children: [
                    /*#__PURE__*/ _jsx(Flex, {
                        flex: "none",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "white.100",
                        width: "20px",
                        height: "20px",
                        borderRadius: "50%",
                        borderStyle: checked ? undefined : "solid",
                        borderWidth: checked ? undefined : "2px",
                        borderColor: checked ? undefined : "grey.600",
                        bg: checked ? "#51c65b" : undefined,
                        mr: 2,
                        children: checked && /*#__PURE__*/ _jsx(CheckOutlined, {})
                    }),
                    /*#__PURE__*/ _jsx(ActivityTodoDescription, {
                        children: formatToReact(description || "No description", "BASIC")
                    })
                ]
            })
        ]
    });
};
export default ActivityTodo;
